export const data = [
  {
    pair: "DELFC4 - ggnfc8",
    value: 3509813,
    otif: 94.4989106753813,
    quantity: 1854
  },
  {
    pair: "DELFC4 - ggnfc5",
    value: 2642368,
    otif: 94.5054945054945,
    quantity: 1477
  },
  {
    pair: "DELFC4 - ggnfc6",
    value: 5287317,
    otif: 94.6306429548564,
    quantity: 2962
  },
  {
    pair: "DELFC4 - ggnfc7",
    value: 2022590,
    otif: 95.1686417502279,
    quantity: 1110
  }
];

export const displayedColumns5 = ["pair", "otif", "value", "quantity"];
